import { getContainer } from '@mews-commander/legacy-app-instance';
import { NotAny } from '@mews/std';

/** @deprecated migrate to generated enums  */
export const localizeEnumify = (enumValue: $TSFixMe) => {
    const container = getContainer();
    const { appLocalizationComponent } = container();

    return appLocalizationComponent.localizeEnumify(enumValue);
};

/** @deprecated use LocalizedEnum or useLocalizeEnum */
export const localizeEnum = <
    Prefix extends keyof Mews.EnumLocalization['prefixes'],
    Value extends Mews.EnumLocalization['prefixes'][Prefix]['valueType'],
>(
    prefix: Prefix,
    enumValue: NotAny<Value>
) => {
    const { appLocalizationComponent } = getContainer()();
    return appLocalizationComponent.localizeEnum(prefix, enumValue);
};
